import {
  ForgeBadgeModule,
  ForgeButtonModule,
  ForgeCalendarModule,
  ForgeCardModule,
  ForgeCheckboxModule,
  ForgeChipModule,
  ForgeChipSetModule,
  ForgeCircularProgressModule,
  ForgeDatePickerModule,
  ForgeDateRangePickerModule,
  ForgeDialogModule,
  ForgeDividerModule,
  ForgeDrawerModule,
  ForgeFloatingActionButtonModule,
  ForgeIconButtonModule,
  ForgeIconModule,
  ForgeLabelValueModule,
  ForgeListItemModule,
  ForgeListModule,
  ForgeMenuModule,
  ForgePageStateModule,
  ForgePaginatorModule,
  ForgeRadioModule,
  ForgeScaffoldModule,
  ForgeSelectModule,
  ForgeTableModule,
  ForgeTextFieldModule,
  ForgeToastModule,
  ForgeTooltipModule,
} from "@tylertech/forge-angular";
import {
  tylIconShareOutline,
  tylIconCloseCircle, tylIconOpenInNew, tylIconContentCopy
} from '@tylertech/tyler-icons/extended';
import {
  tylIconFace,
  tylIconViewDay,
  tylIconViewColumn,
  tylIconViewModule,
  tylIconViewStream,
  tylIconLocationOn,
  tylIconSchedule,
  tylIconClose,
  tylIconCalendarToday,
  tylIconMoreVert,
  tylIconArrowUpward,
} from "@tylertech/tyler-icons/standard";

export const ForgeComponents = [
  ForgeMenuModule,
  ForgeDialogModule,
  ForgeBadgeModule,
  ForgeCalendarModule,
  ForgeScaffoldModule,
  ForgeCardModule,
  ForgeDividerModule,
  ForgeListModule,
  ForgeListItemModule,
  ForgeCheckboxModule,
  ForgeButtonModule,
  ForgeIconModule,
  ForgeTextFieldModule,
  ForgeTableModule,
  ForgeLabelValueModule,
  ForgeChipModule,
  ForgeChipSetModule,
  ForgeTooltipModule,
  ForgeIconButtonModule,
  ForgeDrawerModule,
  ForgeDatePickerModule,
  ForgeSelectModule,
  ForgePageStateModule,
  ForgePaginatorModule,
  ForgeToastModule,
  ForgeDateRangePickerModule,
  ForgeRadioModule,
  ForgeFloatingActionButtonModule,
  ForgeCircularProgressModule
];

export const ForgeIcons = [
  tylIconFace,
  tylIconShareOutline,
  tylIconViewDay,
  tylIconViewColumn,
  tylIconViewModule,
  tylIconViewStream,
  tylIconCloseCircle,
  tylIconClose,
  tylIconLocationOn,
  tylIconSchedule,
  tylIconMoreVert,
  tylIconCalendarToday,
  tylIconArrowUpward,
  tylIconOpenInNew,
  tylIconContentCopy
];
